import axios from './axiosInterceptors';
import authHeader from "./authentification-header";

const API_URL = "/api/v1/material-receiving/";

const importExcelTransactions = (formData, rawExcelData, confirmWithWarning) => {
    return axios
        .post(API_URL + "import-excel-data",
            { formData, rawExcelData, confirmWithWarning }).then((response) => {
                return response.data;
            });
};
const addCoTicketsToTransaction = (selectedTitckets) => {
    return axios.post(API_URL + 'co-ticket/add', selectedTitckets, { headers: authHeader() })
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            console.log("AXIOS ERROR: ", err);
        })
};
const autocompleteCoTicket = (search) => {
    return axios.get(API_URL + 'autocomplete/co-ticket/' + search, { headers: authHeader() })
};
const autocompleteCoTicketByTicket = (ticket) => {
    return axios.post(API_URL + 'autocomplete/co-tickets', ticket, { headers: authHeader() })
};
const allActions = {
    importExcelTransactions,
    addCoTicketsToTransaction,
    autocompleteCoTicket,
    autocompleteCoTicketByTicket
};
export default allActions;